import React from 'react';
import eventManager from '@alife/scc-event-manager/event-manager';
import safeGet from 'src/utils/safe-get';
import globalStore from 'src/utils/global-data-store';
import { getText } from 'src/utils/i18n';

class BuyersCount extends React.PureComponent {
  state = {
    buyers: 0,
  };

  componentDidMount() {
    globalStore.get('transactionOverview').then(res => {
      const buyers = safeGet(res, 'data.totalBuyers');

      if (buyers) {
        this.setState({
          buyers,
        });
      }
    });
  }

  render() {
    const { buyers } = this.state;
    if (!buyers) return null;

    const { style, i18n } = this.props;
    const showSplit = false;
    return (
      <span
        className="quantity-sold"
        style={{ cursor: 'pointer', ...style }}
        onClick={() => {
          eventManager.trigger('changeDetailTab', 'transactionHistory');
        }}
      >
        {showSplit ? (
          <span style={{ color: '#e2e3e8' }}> &nbsp;|&nbsp; </span>
        ) : null}
        {buyers}{' '}
        {buyers > 1
          ? getText(i18n, 'detail_discuss.buyers', 'buyers')
          : getText(i18n, 'detail_discuss.buyer', 'buyer')}
      </span>
    );
  }
}

export default BuyersCount;
